/**
 * Exit Work Status Configuration
 * Single source of truth for exit work status values and labels
 * Used when deactivating a user to track their work status at the time of exit
 */
const EXIT_WORK_STATUS_CONFIG = [
  { key: 'DURING_TRAINING', value: 'during_training', label: 'During Training' },
  { key: 'IN_TRAINING', value: 'in_training', label: 'In Training' },
  { key: 'PRODUCTION', value: 'production', label: 'Production' },
]

export const ExitWorkStatusEnum = Object.fromEntries(
  EXIT_WORK_STATUS_CONFIG.map(({ key, value }) => [key, value])
)

export const ExitWorkStatusLabels = Object.fromEntries(
  EXIT_WORK_STATUS_CONFIG.map(({ value, label }) => [value, label])
)

export const ExitWorkStatusOptions = EXIT_WORK_STATUS_CONFIG.map(({ value, label }) => ({ value, label }))

